<template>
  <div>
    <div class="event-agent-header">
      <h2>{{ $t("agentEntryForm.title") }}</h2>

      <div class="button-wrapper">
        <button class="next" @click="submit" :disabled="selectedNovelIds.length === 0">{{ $t("agentEntryForm.submitButton") }}</button>
      </div>
    </div>

    <template v-if="targetNovels.length === 0">
      <div class="novel-empty">
        <div class="title">{{ $t("agentEntryForm.emptyTitle") }}</div>
        <div class="message">{{ $t("agentEntryForm.emptyMessage") }}</div>
      </div>
    </template>
    <template v-else>
      <div class="novel-list">
        <AgentCampaignNovelListItem
          v-for="novel in targetNovels"
          :key="novel.novelId"
          :campaignId="$route.params.campaignId"
          :novel="novel"
          :selectedNovelIds="selectedNovelIds"
          @input="selectedNovelIds = $event"
        />
      </div>
    </template>

    <MaskedLoading v-if="loading" class="loading" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import AgentCampaignNovelListItem from "@/components/molecules/AgentCampaignNovelListItem.vue";
import MaskedLoading from "@/components/atoms/MaskedLoading.vue";
import { NolaAnalytics, NolaItemId } from "@/lib/utils/analytics";
import { Novel } from "@/lib/models";

export default Vue.extend({
  components: {
    AgentCampaignNovelListItem,
    MaskedLoading,
  },
  data() {
    return {
      selectedNovelIds: [] as string[],
      loading: false,
      nolaAnalytics: new NolaAnalytics(this.$gtm, this.$store),
    };
  },
  computed: {
    targetNovels() {
      return this.$store.getters["novelModule/novels"].filter((i: Novel) => i.title !== "はじめてのNola");
    },
  },
  methods: {
    async submit() {
      this.loading = true;

      try {
        // 選択中の作品を一括（並列処理）でエージェント連携する
        await Promise.all(
          this.selectedNovelIds.map((novelId: string) =>
            this.$store.dispatch("novelModule/requestNolaAgentForNovel", {
              novelId,
              campaignId: this.$route.params.campaignId,
            })
          )
        );

        // 応募完了画面に遷移
        this.$emit("complete");

        // アナリティクス送信
        this.selectedNovelIds.forEach((novelId: string) => {
          this.nolaAnalytics.logButtonEvent(NolaItemId.AgentLink, novelId);
        });
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.loading {
  z-index: 100;
}

.event-agent-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 1.5em;
    color: var(--color-text-normal);
  }
}

.novel-list {
  margin-top: 1rem;
}

.novel-empty {
  margin-top: 5rem;
  text-align: center;

  .title {
    color: var(--color-text-low);
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-lg);
  }

  .message {
    color: var(--color-text-low);
    font-size: var(--font-size-md);
    margin: 10px 0 30px;
  }
}

.button-wrapper {
  display: flex;
  box-sizing: border-box;
  align-items: center;

  button {
    width: fit-content;
    box-sizing: border-box;
    padding: 10px 20px;
    border: 1px solid var(--color-primary);
    border-radius: var(--radius-sm);
    font-weight: var(--font-weight-bold);
    font-size: 1.1em;
    cursor: pointer;

    &:hover {
      filter: brightness(0.95);
    }

    &:disabled {
      background-color: inherit;
      border-color: var(--color-surface-muted);
      color: var(--color-inactive);
      cursor: not-allowed;
    }
  }

  .next {
    background-color: var(--color-primary);
    color: var(--color-text-on-fixed-bg);
  }
}
</style>
